import { RentCatalogMeta, RentCatalogResponse } from '../model/rent-catalog';

const isCatalogMeta = (meta: unknown): meta is RentCatalogMeta => {
  if (!meta || typeof meta !== 'object') {
    return false;
  }

  const value = meta as Partial<RentCatalogMeta>;

  return (
    typeof value.totalElements === 'number' &&
    typeof value.pageNumber === 'number' &&
    typeof value.pageSize === 'number' &&
    typeof value.totalPages === 'number'
  );
};

export const isRentCatalogResponse = (
  data: unknown
): data is RentCatalogResponse => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const catalog = data as Partial<RentCatalogResponse>;

  return (
    Array.isArray(catalog.rentObjects) &&
    isCatalogMeta(catalog.meta) &&
    catalog.fieldsMeta != null &&
    typeof catalog.fieldsMeta === 'object'
  );
};
